import { render, staticRenderFns } from "./EmailMailCard.vue?vue&type=template&id=a6f6a048&functional=true"
import script from "./EmailMailCard.vue?vue&type=script&lang=js"
export * from "./EmailMailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports